import React, { Component } from 'react'
import { Container, Row, Col, Tabs, Tab, Table } from 'react-bootstrap'
import Footer from './Footer'
import HeaderTop from './HeaderTop'
import SideNavTop from './SideNavTop'
import '../Accueil.css'


class MaitreNageur extends Component {
    state = {
        redirect: false,
        search: '',
        key: 'maitre'
    }

    handleCHange = event => {
        const { name, value } = event.target
        this.setState({ [name]: value })
    }

    handleSubmit = event => {
        //on gere le form
        event.preventDefault()
        this.props.history.push(`/recherche/${this.state.search}`);

    }

    setRedirect = () => {
        this.setState({
          redirect: true
        })
      }

    handleSubmitFacebbok = () => {
        if (this.state.redirect) {
            window.location.href = "https://www.facebook.com/clubCAPN/";
        }
    }

    handleSelect(key) {
        if (key === "maitre")
            this.props.history.push(`/competiton/maitres-nageurs`);
        else if (key === "natation")
            this.props.history.push(`/competiton/natation`);
        else if (key === "sauvetage")
            this.props.history.push(`/competiton/sauvetage-sportif`);
        else if (key === "resultat")
            this.props.history.push(`/competiton/resultats`);
        else if (key === "synchro")
            this.props.history.push(`/competiton/nage-synchronisee`);
    }

    render() {
        console.log(this.state.key)
        return (
            <>
                <Container fluid>
                <Row>
            <SideNavTop/>
            <Col lg={10} md={12} sm={12} xs={12} id="page-content-wrapper" className="nopadding">
              <HeaderTop
                handleSubmit={this.handleSubmit}
                handleCHange={this.handleCHange}
                handleSubmitFacebbok={this.handleSubmitFacebbok}
                setRedirect={this.setRedirect}
              />

                            <Col lg={12} md={12} sm={12} xs={12} className="nopadding">

                                <Tabs
                                    id="controlled-tab"
                                    activeKey={this.state.key}
                                    onSelect={key => this.handleSelect(key)}
                                >                       <Tab eventKey="maitre" title="Maître Nageurs">
                                    </Tab>
                                    <Tab eventKey="synchro" title="Nage synchronisée">
                                    </Tab>
                                    <Tab eventKey="natation" title="Natation" >
                                    </Tab>
                                    <Tab eventKey="sauvetage" title="Sauvetage sportif">
                                    </Tab>
                                    <Tab eventKey="resultat" title="Résultats des compétitions" >
                                    </Tab>
                                </Tabs>
                            </Col>


                            <Col lg={12} md={12} sm={12} xs={12} className="nopadding">
                                <Row>
                                    <Col lg={12} md={12} sm={12} xs={12} className="nopadding">
                                        <div className="histoire-content">
                                            <h1><span>Maîtres Nageurs - Saison 2020-2021</span></h1>
                                            <h2>INFORMATIONS</h2>
                                            <p className="pCenter">Le club des maîtres nageurs permet aux adultes de 18 ans et plus de parfaire leurs techniques de nage, d'apprendre les techniques de compétition et de nager
                                            dans un milieu convivial avec des gens sympatiques qui partagent les mêmes intérêts sportifs.
                                             Il est à noter que les places sont très limitées.<br />

                                             Inscription: 2 septembre 2020<br />

                                            <strong>Coût:</strong> 450$ + affiliation obligatoire :  Compétitif  53$<br />

                                            Non-compétitif  37$<br />

                                            <strong>Durée:</strong> 8 septembre 2020 au 12 juin 2021<br />

                                            Prendre note qu'il y aura arrêt d'entraînements pour la période des fêtes du 19 décembre 2020
                                             au 3 janvier 2021 inclusivement ainsi que la semaine de relâche<br /><br />
                                            </p>
                                            <h2>HORAIRES D'ENTRAINEMENT</h2>
                                            <h3>Tous les entrainements ont lieux à la piscine Sophie-Barat!!</h3>

                                            <Table striped bordered hover>
                                            <thead>
                                                <tr>
                                                <th>Lundi</th>
                                                <th>Mardi</th>
                                                <th className="table-resp">Mercredi</th>
                                                <th>Jeudi</th>
                                                <th className="table-resp">Vendredi</th>
                                                <th>Samedi</th>
                                                <th className="table-resp">Dimanche</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr>
                                                <td></td>
                                                <td>6h15 à 7h45</td>
                                                <td className="table-resp"></td>
                                                <td>6h15 à 7h45</td>
                                                <td className="table-resp"></td>
                                                <td>7h00 à 8h30</td>
                                                <td className="table-resp"></td>
                                                </tr>
                                                <tr>
                                                <td>20h30 à 22h00</td>
                                                <td></td>
                                                <td className="table-resp"></td>
                                                <td>20h30 à 22h00</td>
                                                <td className="table-resp"></td>
                                                <td></td>
                                                <td className="table-resp"></td>
                                                </tr>
                                            </tbody>
                                            </Table>
                                            <div className="pCenter">
                                                <p className="pCenter"> Lien<br/></p> <a className="link-history" href="https://www.fnq.qc.ca">Fédération de natation du Québec</a><br/>
                                                <a className="link-history" href="https://www.mymsc.ca">Maîtres-nageurs du Canada</a>
                                            </div>
                                        </div>
                                    </Col>
                                </Row>
                            </Col>

                            <Col lg={12} md={12} sm={12} xs={12} className="nopadding">
                                <Footer />
                            </Col>
                        </Col>
                    </Row>
                </Container>
            </>
        )
    }
}

export default MaitreNageur
